import AbstractRequestTask from "../AbstractRequestTask";
import Device from "../../../devices/device";

class ApaAssetTask extends AbstractRequestTask {
  constructor(region = "", appKey = '') {
    super();

    this.region = region;
    this.appKey = appKey;
  }

  getUrl() {
    return `${Device.getDevice().getConfig().akamai_mfwk}/services/apa/asset`;
  }

  getParams() {
    const params = super.getParams();

    const appKey = this.appKey ? this.appKey : Device.getDevice().getConfig().appKey;
    const region = this.region || params.region;
    const sessionKey = `${appKey}-${region}`;

    return Object.assign({}, params, { sessionKey } );
  }

  isValid(data = null) {
    return !!data;
  }

  success(data, b) {
    this.resolve(data);
  }

  getRetriesNumber() {
    if (this.appKey) {
      return 0;
    }  
  }
}

export default ApaAssetTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/application/ApaAssetTask.js